import Dexie from "dexie";
import db from "../Db";

var UpdateClientDateSynchro = Dexie.async(function* (DATE) {
  yield db.open();
  yield db.CLIENT.update(1, { DATE_SYNCHRO: DATE.replace(/"/g, "") });
});

export default UpdateClientDateSynchro;
